import { ErrorCard } from '#/shared/components/ErrorCard';
import { Container } from '#/shared/components/layout/Container';

export function VerificationSuccessScreen() {
  return (
    <Container className="flex flex-1 flex-col items-center justify-center space-y-4">
      <ErrorCard
        title="Timesheet verified"
        description="The timesheet has been verified and sent to the approver for approval."
      />
    </Container>
  );
}
